import { useState, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

export default function QuoteForm() {
  const [services, setServices] = useState([]);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    service_type: '',
    message: '',
  });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api.get('/services')
      .then((res) => setServices(Array.isArray(res.data) ? res.data : []))
      .catch(() => {});
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error('Ad ve telefon alanlari zorunludur');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/quotes', form);
      toast.success('Teklif talebiniz başarıyla gönderildi');
      setForm({ name: '', phone: '', email: '', service_type: '', message: '' });
    } catch (err) {
      toast.error('Gönderme sırasında hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="quote-form">
      <h3>Ücretsiz Teklif Alın</h3>
      <form onSubmit={handleSubmit}>
        <div className="quote-form-grid">
          <div className="form-group">
            <label>Ad Soyad *</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Adınız Soyadınız"
              required
            />
          </div>
          <div className="form-group">
            <label>Telefon *</label>
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="05XX XXX XX XX"
              required
            />
          </div>
          <div className="form-group">
            <label>E-posta</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="ornek@email.com"
            />
          </div>
          <div className="form-group">
            <label>Hizmet Turu</label>
            <select
              name="service_type"
              value={form.service_type}
              onChange={handleChange}
            >
              <option value="">Seçiniz</option>
              {services.map((s) => (
                <option key={s.id} value={s.title}>
                  {s.title}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-group">
          <label>Mesajiniz</label>
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            rows="4"
            placeholder="Projeniz hakkında detayları yazabilirsiniz..."
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? 'Gonderiliyor...' : 'Teklif Iste'}
        </button>
      </form>
    </div>
  );
}
